import React, { useRef, useEffect, useState } from 'react'
import './Statistics.css'
import { getDatabase, get, push, ref, runTransaction } from 'firebase/database'
import { useHistory } from 'react-router-dom'
import Navigation from '../../navigation/Navigation'
import PageHeading from '../../shared/pageHeading/PageHeading'

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faUserPlus } from '@fortawesome/free-solid-svg-icons'

const AddCustomer = () => {
    const [dates, setDates] = useState()
    const [allTransactions, setAllTransactions] = useState([])
    const [transactionsGroupedByDate, setTransactionsGroupedByDate] = useState([])
	const [transactionsGroupedByHour, setTransactionsGroupedByHour] = useState([])
	const db = getDatabase()
	useEffect(() => {
		get(ref(db, 'schedule/'))
			.then((snapshot) => {
				if (snapshot.exists()) {
					console.log('GetDates', snapshot.val())
					setDates(snapshot.val())
				}
			})
			.catch((error) => {
				console.error('@Report-->', error)
			})
		get(ref(db, 'transactions/'))
			.then((snapshot) => {
				if (snapshot.exists()) {
					console.log('transactions', snapshot.val())
					const groupBy = (array, key) => {
						// Return the end result
						return array.reduce((result, currentValue) => {
							// If an array already present for key, push it to the array. Else create an array and push the object
							;(result[currentValue[key]] =
								result[currentValue[key]] || []).push(currentValue)
							// Return the current iteration `result` value, this will be taken as next iteration `result` value and accumulate
							return result
						}, {}) // empty object is the initial value for result object
					}
		
					let ArrayOfTransactions = Object.entries(snapshot.val())
						.map(([table, transactions]) =>
							Object.entries(transactions).map(([data, transaction]) => {
								transaction.hour = new Date(transaction.time).getHours()
								transaction.date = new Date(transaction.time).getDate()
								return transaction
							})
						)
                        .flat()
                         
                        setAllTransactions(ArrayOfTransactions)
					const TransactionsGroupedByDate = groupBy(
						ArrayOfTransactions,
						'date'
					)
					const TransactionsGroupedByHour = Object.entries(
						TransactionsGroupedByDate
					).map(([date, transactions]) => {
						return {
							[date]: groupBy(transactions, 'hour'),
						}
					})

					console.log(
						'TransactionsGroupedByDate',
						TransactionsGroupedByDate
					)
					console.log(
                        'TransactionsGroupedByHour',
                        
						TransactionsGroupedByHour
                    )
                    setTransactionsGroupedByDate(TransactionsGroupedByDate)
					setTransactionsGroupedByHour(TransactionsGroupedByHour)
				}
			})
			.catch((error) => {
				console.error('@Report-->', error)
			})
	}, [])
	/*
    useEffect(() => {
        query(ref(db, 'transactions'), startAt(dates.friday.start)('time').then(snapshot=>{
            console.log(snapshot.val())
        })
    },[dates])
*/

	return (
		<>
			<Navigation />
			<div className="AppContents">
				<div className="Container">
					<PageHeading heading={'Statistik'} />
					<section>
                        <div className="DayBlock">
                            <div className="Date">Vårloppis 2022</div>
                        <div>Transaktioner: {allTransactions.length}</div>
                        <div>Försäljning: {allTransactions.reduce((a, b) => a + (b.sum || 0), 0).toFixed(2)} €</div>
                        </div>
                    {Object.entries(transactionsGroupedByDate).map(([date, transactionsPerDate])=>{
                        return(
                            <div className="DayBlock">
                                <div className="Date">{date}.04.2022</div>    
                                <div>Transaktioner: {transactionsPerDate.length}</div>
                                <div>Försäljning: {transactionsPerDate.reduce((a, b) => a + (b.sum || 0), 0).toFixed(2)} €</div>
                            </div>
                        )
                    })}
                    {transactionsGroupedByHour.map((tables) => {
                        return Object.entries(tables).map(([date, transactionsPerDay]) => {
                            return(
                                <div className="DayBlock">
                                    <div className="Date">{date}.04.2022</div>                                                  
                                    {Object.entries(transactionsPerDay).map(([hour, transactionsPerHour]) => {
                                        return(
                                            <div className="Stats">
                                                <div className="Hour">{hour}:00 - {Number(hour)+1}:00</div>
                                                <div>Transaktioner: {transactionsPerHour.length}</div>
                                                <div>Försäljning: {transactionsPerHour.reduce((a, b) => a + (b.sum || 0), 0).toFixed(2)} €</div>
                                            </div>
                                        )
                                    })}
                                </div>
                            )
                           
						})
					})}					
					</section>
				</div>
			</div>
		</>
	)
}

export default AddCustomer
